import { DownloadOutlined, InboxOutlined, UploadOutlined } from '@ant-design/icons';
import { Table } from 'ant-table-extensions';
import { message, Modal, Tooltip, Typography, Upload } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useEffect, useState } from 'react';
import { getListOfCustomerExpiredTasks } from '../../api/NetworkingTasks';
import { getResource } from '../../helpers/ResourcesHelper';
import Button from '../inputs/Button';

const { Dragger } = Upload;

class Task {
  DeadLineDate: string;
  EntityTaskId: string;
  ExpiryDate  : string | null;
  Title       : string;
  UpdateToken : string;

  constructor(deadline:string, entityTaskId:string, expiryDate:string|null, title:string, updateToken:string){
    this.DeadLineDate = deadline;
    this.EntityTaskId = entityTaskId;
    this.ExpiryDate   = expiryDate;
    this.Title        = title;
    this.UpdateToken  = updateToken;
  }
}

const RequiredDocuments = () => {
  const [updating, setUpdating] = useState<boolean>(true);

  const [requiredFileList, setRequiredFileList] = useState([]);
  const [taskSelected, setTaskSelected] = useState<Task>(new Task('','',null,'',''));

  const [showModalUpload, setShowModalUpload] = useState<boolean>(false);

  const [fileUploaded, setFileUploaded] = useState<any>();

  useEffect(() => {
    let userSession = JSON.parse(localStorage.getItem('UserSession')!);
    getListOfCustomerExpiredTasks(userSession.CustomerID).then(
      (jsonResponse) =>
      {
        if(jsonResponse !== undefined && jsonResponse.tasks !== undefined)
        {
          let requiredDocs = jsonResponse.tasks;
          /*
            { 
              DeadLineDate: "2020-12-30T10:26:29.687"
              EntityTaskId: "A1BF5508-6662-4C01-9E32-B269A6AEFE07"
              ExpiryDate: null
              Title: "Address verification"
              UpdateToken: "637362807896866667"
            }
          */
          setRequiredFileList(requiredDocs);
        }
      }
    );
  }, [updating]);

  const columns: ColumnsType<Task> = [
    {
      title: getResource('Table_TH_Title'),
      dataIndex : 'Title',
      key       : 'task_title',
      align     : 'left',
    },
    {
      title: getResource('Table_TH_ExpiryDate'),
      dataIndex : 'ExpiryDate',
      key       : 'task_expirydate',
      align     : 'center',
      render    : (value: any, obj: Task, index: any) =>(
        <span>{obj.ExpiryDate === null ? '' : obj.ExpiryDate}</span>
      ),
    },
    {
      title: getResource('Table_TH_Action'),
      key    : 'action',
      align  : 'center',
      render : (value: any, obj: Task, index: any) => (
        <Tooltip title={getResource('Upload')}>
          <Typography.Link
            onClick={()=>{
              setTaskSelected(obj);
              setShowModalUpload(true);
            }}
          >
            <UploadOutlined style={{fontSize: 18}}/>
          </Typography.Link>
        </Tooltip>
      ),
    },
  ];

  const props = {
    name: 'file',
    multiple: true,
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    onChange(info:any) {

      if(info.fileList[0] !== undefined)
      {
        setFileUploaded(info.fileList[0]);
      }else{
        setFileUploaded(undefined);
      }

      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} ` + getResource('FileUploaded'));
      } else if (status === 'error') {
        message.error(`${info.file.name} ` + getResource('FileUploadedError'));
      }
    },
    onDrop(e:any) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };
  
  return (
    <div className="row center-xs">
      <Table
        className  = 'col-md-6 slide-r-l'
        key        = {'requiredFileList-table'}
        columns    = {columns} 
        dataSource = {requiredFileList} 
        exportableProps={{
          fileName: 'RequiredDocuments',
          btnProps: {
            type: "default",
            icon: <DownloadOutlined />,
          }
        }}
      />
      <Modal
        title    = {
          <h3 className="component-title">{taskSelected.Title}</h3>}
        centered
        visible  = {showModalUpload}
        footer   = {null}
        onCancel = {()=>{setShowModalUpload(false);}}
        width    = {'50%'}
        zIndex   = {1021}
      >
        <Dragger
          {...props}
          //name      = {taskSelected.Title + 'file'}
          //multiple  = {false}
          //action    = 'https://www.mocky.io/v2/5cc8019d300000980a055e76'
          /*onChange  = {
            (info: any) => {
              if(info.fileList[0] !== undefined)
              {
                setFileUploaded(info.fileList[0]);
              }else{
                setFileUploaded(undefined);
              }
              /*const { status } = info.file;
              if (status !== 'uploading') {
                console.log(info.file, info.fileList);
              }
              if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
              } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
              }
            }
          }
          onDrop = {
            (e:any) => {
              console.log('Dropped files -> ', e);
            }
          }*/
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{getResource('ClickOrDrag')}</p>
        </Dragger>
        <div className="row center-md center-xs">
          <div className="col-md-4 col-xs-12 center-md">
            <Button 
              type    = "secondary" 
              onClick = {()=>{setShowModalUpload(false);}}
            >{getResource('Button.Cancel')}</Button>
          </div>
          <div className="col-md-4 col-xs-12 center-md">
            <Button 
              type    = {fileUploaded !== undefined ? "primary" : 'disable'}
            >{getResource('Upload')}</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default RequiredDocuments;